import React from "react";
import { Link } from "react-router-dom";
import home from "../content/home.json";

const AboutSection = () => {
  const { about } = home;
  return (
    <section
      data-testid="about-section"
      className="py-20 md:py-24 bg-ivory-deeper"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center">
          <div className="md:col-span-5 order-2 md:order-1">
            <div className="aspect-square overflow-hidden border border-charcoal/15 bg-ivory max-w-[420px] md:ml-auto">
              <img
                src={about.placeholderImage}
                alt={about.placeholderImageAlt}
                data-testid="about-placeholder-image"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="md:col-span-7 order-1 md:order-2">
            <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
              {about.overline}
            </p>
            <h2
              data-testid="about-heading"
              className="mt-6 font-heading font-normal text-charcoal text-4xl sm:text-5xl md:text-6xl leading-[1.08] tracking-tight"
            >
              {about.heading}
            </h2>
            <div className="mt-6 w-12 h-px bg-muted_gold" />
            {about.paragraphs.map((p, i) => (
              <p
                key={i}
                className="mt-6 text-charcoal-soft text-base md:text-lg leading-relaxed max-w-xl"
              >
                {p}
              </p>
            ))}
            <Link
              to={about.cta.to}
              data-testid="about-cta-authenticity"
              className="mt-8 inline-block border border-charcoal/40 text-charcoal px-10 py-4 text-xs tracking-[0.32em] uppercase font-medium hover:border-muted_gold hover:text-muted_gold transition-colors duration-500"
            >
              {about.cta.label}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
